import { Collection } from '../collections/collections.types';
import { Brand } from '../context/ApplicationContext/applicationContext.types';
import { Customer } from '../customer/types/customer.types';
import { AvailabilityEnum, DeliveryWindow } from '../products/ProductTypes';
import { UserRole } from '../users/roles';

interface CommercialPolicyDTO {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  discount: number;
  minimumValue?: number;
  availability?: Exclude<AvailabilityEnum, 'EMPTY'>[];
  available: boolean;
  brand: Brand;
  orderCollections?: Collection[];
  paymentMethods: PaymentMethod[];
  customers?: Customer[];
  deliveryWindows: DeliveryWindow[];
}

export interface ReleasedByBusinessPolicyDTO {
  businessPolicyId: string;
  name: string;
}

export interface GetPaymentMethodDTO {
  id: string;
  name: string;
  code: string;
  active: boolean;
  description: string;
  type: PaymentMethodType;
  availability: AvailabilityEnum[];
  orderDiscount: number;
  allowedRoles: UserRole[];
  orderDiscountCode?: number;
  restrictToCommercialPolicies: boolean;
  tagLabel: string | null;
  accumulatedInterestPercentage: number;
  requirePaymentGateway: boolean;
  paymentValueType: PaymentValueType | null;
  minimumPaymentPercentage: number | null;
  supplementaryPayment: SupplementaryPaymentType | null;
  maxInstallments: number;
}

export interface UpdatePaymentMethodDTO {
  name: string;
  code: string;
  active: boolean;
  description: string;
  type: PaymentMethodType;
  availability: AvailabilityEnum[];
  orderDiscount: number;
  allowedRoles: UserRole[];
  orderDiscountCode?: number;
  restrictToCommercialPolicies: boolean;
  tagLabel: string | null;
  accumulatedInterestPercentage: number;
  requirePaymentGateway?: boolean;
  paymentValueType?: PaymentValueType | null;
  minimumPaymentPercentage?: number | null;
  supplementaryPayment?: SupplementaryPaymentType | null;
  maxInstallments?: number;
}

export interface PaymentMethod {
  active: true;
  allowedRoles: UserRole[];
  availability: AvailabilityEnum[];
  code: string;
  commercialPolicies?: CommercialPolicyDTO[];
  policies?: ReleasedByBusinessPolicyDTO[];
  description: string;
  id: string;
  name: string;
  orderDiscount: number;
  orderDiscountCode: number;
  restrictToCommercialPolicies: boolean;
  type: PaymentMethodType;
  tagLabel?: string;
  accumulatedInterestPercentage: number;
  requirePaymentGateway?: boolean;
  paymentValueType?: PaymentValueType | null;
  minimumPaymentPercentage?: number | null;
  supplementaryPayment?: SupplementaryPaymentType | null;
}

export enum PaymentMethodType {
  BANK_SLIP = 'BANK_SLIP',
  CREDIT_CARD = 'CREDIT_CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  BANK_CHECK = 'BANK_CHECK',
  PIX = 'PIX',
}

export enum PaymentValueType {
  PARTIAL_VALUE = 'PARTIAL_VALUE',
  FULL_VALUE = 'FULL_VALUE',
}

export enum SupplementaryPaymentType {
  BANK_SLIP = 'BANK_SLIP',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  POS_RECEIPT = 'POS_RECEIPT',
  GIFT_CHECK = 'GIFT_CHECK',
  PAYPAL = 'PAYPAL',
  INVOICE = 'INVOICE',
  ADVANCE = 'ADVANCE',
  VOUCHER = 'VOUCHER',
  PICPAY = 'PICPAY',
  PIX = 'PIX',
}
